import type { FaireProductEntity } from "../../entity_types/product";

export const p_4jencz3und: FaireProductEntity = {
  token: "p_4jencz3und",
  type: "product",
  name: "Off Leash Birthday Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/8b1da4540786ef7834ebff681b36d06879e4d8c5da9df06f31bf51b5397ae0c2.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2c0a303e03f33f67420d4c8ccf1bd6480427e492f16bd7d68f3c06a5b2ccec2a.jpeg",
    "https://cdn.faire.com/fastly/34841fa5f25d09cdf13ec624c75651efa31ebee43d703dc5e34eef6811321ac8.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:35:54.353Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
